import { AkaStudentProductIntroFormValues } from "./akaStudentProductIntroInterfaces";

export const AKA_STUDENT_PRODUCT_INTRO_INITIAL_FORM_VALUES: Partial<AkaStudentProductIntroFormValues> =
  {
    country: undefined,
  };
